import React from 'react';
import Typography from '@material-ui/core/Typography';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';

import { Company } from '../../../../../../models/Common';
import { colors } from '../../../../../../themes/colors';
import { CompanyNameTestID } from './constants';

const styles = (theme) =>
  createStyles({
    companyName: {
      color: colors.black1,
      fontSize: 14,
      fontWeight: 500,
    },
  });

interface CompanyNameProps {
  company: Company;
}

type Props = WithStyles<typeof styles> & CompanyNameProps;

const CompanyName: React.FC<Props> = ({ classes, company }) => (
  <div data-testid={CompanyNameTestID}>
    <Typography className={classes.companyName}>{company.name}</Typography>
  </div>
);

export default withStyles(styles)(CompanyName);
